//----------------------------
// validate character profile
//----------------------------
export default function validateCharacterProfile(now, original) {
  console.log('-----------------------')
  console.log('IN validateCharacterProfile')
  let error = {
    msg: '',
    field: '',
    tab: '',
  }
  //--------------
  // name missing
  //--------------
  if (now.name == '' || now.name == undefined) {
    error.msg = 'Name missing'
    error.field = 'name'
    error.tab = 'pills-profile-tab'
    //--------------
    // status missing
    //--------------
  } else if (now.status == '' || now.status == undefined) {
    error.msg = 'Status missing'
    error.field = 'status'
    error.tab = 'pills-profile-tab'
    //------------------
    // category missing
    //------------------
  } else if (now.category == '' || now.category == undefined) {
    error.msg = 'Category missing'
    error.field = 'category'
    error.tab = 'pills-profile-tab'
    //--------------
    // type missing
    //--------------
  } else if (now.type == '' || now.type == undefined) {
    error.msg = 'Type missing'
    error.field = 'type'
    error.tab = 'pills-profile-tab'
    //--------------
    // race missing
    //--------------
  } else if (now.race_name == '' || now.race_name == undefined) {
    error.msg = 'Race missing'
    error.field = 'race_name'
    error.tab = 'pills-profile-tab'
    //--------------
    // role missing
    //--------------
  } else if (now.role == '' || now.role == '') {
    error.msg = 'Role missing'
    error.field = 'role'
    error.tab = 'pills-profile-tab'
    //--------------------------------------
    // player missing where party character
    //--------------------------------------
  } else if (
    (now.player_name == '' || now.player_name == undefined) &&
    now.category == 'Party' &&
    now.type == 'Character'
  ) {
    error.msg = 'Player missing for party character'
    error.field = 'player_name'
    error.tab = 'pills-profile-tab'
    //
    //-------------
    // age missing
    //-------------
  } else if (now.age == '' || now.age == undefined) {
    error.msg = 'Age missing'
    error.field = 'age'
    error.tab = 'pills-profile-tab'
    //----------------
    // age not 1-3000
    //----------------
  } else if (now.age > 3000 || now.age < 1) {
    error.msg = 'Age must be in range 1-3000'
    error.field = 'age'
    error.tab = 'pills-profile-tab'
    //
    //----------------
    // height missing
    //----------------
  } else if (now.height == '' || now.height == undefined) {
    error.msg = 'Height missing'
    error.field = 'height'
    error.tab = 'pills-profile-tab'
    //------------------
    // height not 1-999
    //------------------
  } else if (now.height > 999 || now.height < 1) {
    error.msg = 'Height must be in range 1-999'
    error.field = 'height'
    error.tab = 'pills-profile-tab'
    //
    //----------------
    // weight missing
    //----------------
  } else if (now.weight == '' || now.weight == undefined) {
    error.msg = 'Weight missing'
    error.field = 'weight'
    error.tab = 'pills-profile-tab'
    //------------------
    // weight not 1-999
    //------------------
  } else if (now.weight > 999 || now.weight < 1) {
    error.msg = 'weight must be in range 1-999'
    error.field = 'weight'
    error.tab = 'pills-profile-tab'
    //
    //---------------------
    // cock missing (male)
    //---------------------
  } else if (now.gender == 'Male' && (now.cock == '' || now.cock == undefined)) {
    error.msg = 'Cock length missing'
    error.field = 'cock'
    error.tab = 'pills-profile-tab'
    //----------------------
    // cock not 1-14 (male)
    //----------------------
  } else if (now.gender == 'Male' && (now.cock > 14 || now.cock < 1)) {
    error.msg = 'Cock length must be in range 1-14'
    error.field = 'cock'
    error.tab = 'pills-profile-tab'
  }
  //--------------
  // return error
  //--------------
  return error
}
